import createAdapter from './createAdapter'
export const revcontent = createAdapter(() => true, {
  track(eventName) {
    const img = document.createElement('img')
    let token
    switch (eventName) {
      case 'Purchase':
        token =
          'dS8Gl%2BdYH15Rh0pb6cLL9qbsFUruX%2B8xOrjbFcGHMLVhvy%2Bpt9S093AFmT373RPn'
        break
      case 'Install':
        token =
          '97ChjefPmChZGm07k%2BUhohbQk%2BjCumfTO4Fh7QwB23TBiV8CUOqTDm5wVptWivxP'
        break
      default:
        return
    }
    img.setAttribute('src', `//trends.revcontent.com/conv.php?t=${token}`)
    document.getElementsByTagName('body')[0].appendChild(img)
  },
})
